"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyUpdater = exports.cleanState = exports.applyBindingToFilters = exports.copyWithoutKey = exports.hasAnyOfThisValues = exports.customFilterUpdater = exports.filterUpdater = exports.queryUpdater = exports.SearchContext = void 0;
const react_1 = require("react");
const constants = __importStar(require("./constants"));
exports.SearchContext = (0, react_1.createContext)({});
const queryUpdater = (query) => state => (Object.assign(Object.assign({}, state), { query }));
exports.queryUpdater = queryUpdater;
const filterUpdater = (id, filter) => state => (Object.assign(Object.assign({}, state), { filters: Object.assign(Object.assign({}, state.filters), { [id]: filter }) }));
exports.filterUpdater = filterUpdater;
const customFilterUpdater = (id, filter) => state => (Object.assign(Object.assign({}, state), { customFilters: Object.assign(Object.assign({}, state.customFilters), { [id]: filter }) }));
exports.customFilterUpdater = customFilterUpdater;
const readPropertyBindings = (property) => {
    const propertyBinds = property[constants.GuiBind];
    const propertyTarget = property['gui:target'];
    if (propertyTarget === undefined || propertyBinds === undefined)
        return [];
    return propertyBinds.map(bind => ({
        target: propertyTarget,
        boundTo: bind['gui:target'],
        values: bind['gui:values'],
    }));
};
const getPropertiesTargets = (group) => group['gui:properties'].filter(prop => prop['gui:target'] !== undefined).map(prop => prop['gui:target']);
const readGroupBindings = (group) => {
    const groupBind = group[constants.GuiBind];
    if (groupBind === undefined)
        return [];
    return getPropertiesTargets(group)
        .flatMap(target => groupBind.map(bind => [target, bind]))
        .map(([target, bind]) => ({
        target,
        boundTo: bind['gui:target'],
        values: bind['gui:values'],
    }));
};
const readBinding = (config) => {
    const groups = config['gui:groups'];
    if (groups === undefined)
        return [];
    return groups.flatMap(group => {
        const propertyBindings = group['gui:properties'].flatMap(prop => readPropertyBindings(prop));
        return readGroupBindings(group).concat(propertyBindings);
    });
};
const hasAnyOfThisValues = (filterValues, values) => filterValues && filterValues.length > 0 && filterValues.every(a => values.indexOf(a) > -1);
exports.hasAnyOfThisValues = hasAnyOfThisValues;
const copyWithoutKey = (key, _a) => {
    var _b = key, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
    return rest;
};
exports.copyWithoutKey = copyWithoutKey;
const applyBindingToFilters = (filters, binding) => {
    const filter = filters[binding.target];
    if (filter === undefined)
        return filters;
    const boundToFilter = filters[binding.boundTo];
    return (0, exports.hasAnyOfThisValues)(boundToFilter, binding.values) ? filters : (0, exports.copyWithoutKey)(binding.target, filters);
};
exports.applyBindingToFilters = applyBindingToFilters;
const cleanState = (state, config) => {
    const newFilters = readBinding(config).reduce(exports.applyBindingToFilters, state.filters);
    return newFilters === state.filters ? state : Object.assign(Object.assign({}, state), { filters: newFilters });
};
exports.cleanState = cleanState;
const applyUpdater = (state, updater, config) => (0, exports.cleanState)(updater(state), config);
exports.applyUpdater = applyUpdater;
